
import React from 'react';

interface SafetyProps {
  onBack: () => void;
}

const Safety: React.FC<SafetyProps> = ({ onBack }) => {
  return (
    <div className="pt-24 pb-20 bg-white min-h-screen">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <button 
          onClick={onBack}
          className="mb-12 flex items-center text-slate-400 hover:text-[#2E4A96] transition-colors font-bold uppercase text-xs tracking-widest"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
          Back to Home
        </button>

        <div className="mb-20">
          <div className="flex mb-6">
            <div className="w-12 h-2 bg-[#2E4A96] rounded-sm"></div>
            <div className="w-12 h-2 bg-[#1CB496] rounded-sm ml-1"></div>
          </div>
          <h1 className="text-5xl md:text-7xl font-black text-slate-900 mb-8 tracking-tight">Safety & Quality Protocols</h1>
          <p className="text-xl text-slate-500 font-medium leading-relaxed max-w-3xl">
            At Whitefield Health, safety isn't a feature—it's the core of our clinical foundation. We maintain the highest standards of verification and clinical oversight in Bangalore.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
          <div className="bg-slate-50 p-10 rounded-[2.5rem] border border-slate-100 shadow-sm">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-2xl mb-8 shadow-sm">🛡️</div>
            <h3 className="text-2xl font-black text-slate-900 mb-4">Staff Verification</h3>
            <ul className="space-y-4">
              {[
                "Mandatory Police Verification (e-PCC)",
                "3-Step Clinical Background Check",
                "Aadhar & Permanent Address Authentication",
                "Neighbor Reference Check for Hyper-Local Staff"
              ].map((item, i) => (
                <li key={i} className="flex items-start text-slate-600 font-semibold text-sm">
                  <svg className="w-5 h-5 text-[#1CB496] mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-slate-50 p-10 rounded-[2.5rem] border border-slate-100 shadow-sm">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-2xl mb-8 shadow-sm">🏥</div>
            <h3 className="text-2xl font-black text-slate-900 mb-4">Clinical Standards</h3>
            <ul className="space-y-4">
              {[
                "Daily Nurse Supervisor Check-ins",
                "Sterilized Equipment Protocol",
                "Digital Health Records (Encrypted)",
                "Emergency Rapid Response Training"
              ].map((item, i) => (
                <li key={i} className="flex items-start text-slate-600 font-semibold text-sm">
                  <svg className="w-5 h-5 text-[#2E4A96] mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="bg-[#2E4A96] text-white p-12 rounded-[3rem] shadow-2xl shadow-blue-900/20 text-center md:text-left md:flex items-center justify-between">
          <div className="max-w-xl mb-8 md:mb-0">
            <h2 className="text-3xl font-black mb-4">24/7 Quality Assurance</h2>
            <p className="text-blue-100 font-medium opacity-90 leading-relaxed">
              Every home visit is monitored by our central clinical desk in Whitefield. We ensure zero deviation from prescribed care plans.
            </p>
          </div>
          <div className="inline-block bg-[#1CB496] text-white font-black px-10 py-5 rounded-2xl whitespace-nowrap text-lg shadow-lg select-all">
            9986928692
          </div>
        </div>
      </div>
    </div>
  );
};

export default Safety;
